import Footer from '../../../components/Footer/footer.component';
import { Helmet } from 'react-helmet-async';
import './disclaimer.style.css';
import FooterNew from '../../../components/Footer/section-footer';

const DisclaimerPolicy = () => {
  return (
    <>
      <Helmet>
        <title> Disclaimer Policy | Ahguide </title>
        <meta
          name="description"
          content="Ahguide does not make any warranties about the completeness,
          reliability and accuracy of this information. Any action you take upon
          the information you find on this website (Ahguide), is strictly at
          your own risk."
        />
        <link rel="canonical" href="https://www.ahguide.in/disclaimer-policy" />
      </Helmet>
      <div className="section">
        <div className="container">
          <h2 className="heading-secondary">Disclaimer Policy</h2>

          <p className="header-description">
            All the information on this website - https://www.ahguide.in - is
            published in good faith and for general information purpose only.
            Ahguide does not make any warranties about the completeness,
            reliability and accuracy of this information. Any action you take
            upon the information you find on this website (Ahguide), is strictly
            at your own risk. Ahguide will not be liable for any losses and/or
            damages in connection with the use of our website.
          </p>

          <p className="header-description">
            From our website, you can visit other websites by following
            hyperlinks to such external sites. While we strive to provide only
            quality links to useful and ethical websites, we have no control
            over the content and nature of these sites. These links to other
            websites do not imply a recommendation for all the content found on
            these sites. Site owners and content may change without notice and
            may occur before we have the opportunity to remove a link which may
            have gone 'bad'.
          </p>

          <p className="header-description">
            Please be also aware that when you leave our website, other sites
            may have different privacy policies and terms which are beyond our
            control. Please be sure to check the Privacy Policies of these sites
            as well as their "Terms of Service" before engaging in any business
            or uploading any information.
          </p>

          <h3 className="heading-tertiary">Consent</h3>

          <p className="header-description">
            By using our website, you hereby consent to our disclaimer and agree
            to its terms.
          </p>

          <h3 className="heading-tertiary">Update</h3>

          <p className="header-description">
            Should we update, amend or make any changes to this document, those
            changes will be prominently posted here.
          </p>
        </div>
      </div>
      <FooterNew />
    </>
  );
};

export default DisclaimerPolicy;
